<template>
<div class="chapter">
<div class="inner_page">
<p class="image"><img alt="images" src="images/f010-01.jpg" width="80%"/></p>
<p class="caption"><em class="italic">The pattern of headstone marking the grave of Private Daniel Rees is of a standard pattern across all First and Second World War CWGC cemeteries. Post-war headstones are marked by a notch cut into both shoulders at the top</em>.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 10_fm025.vue?af89d4c0